<template>
    <div class="flex-none z-2 w-full fixed" v-if="!hideHeader">
        <div class="w-full flex surface-0" style="height:62px">
            <div class="center w-full flex align-items-center align-items-center px-3">
                <slot name="left">
                    <div class="flex gap-2 align-items-center justify-content-start">
                        <!--LEFT FIRST-->
                        <div v-if="btnLeftFirst && btnLeftFirst.visible && btnLeftFirst.type">
                            <!--Avatar-->
                            <div v-if="btnLeftFirst.type=='avatar'" class="header_avatar flex">
                                <Avatar v-if="userPhoto" :image="userPhoto" size="medium" shape="circle" @click="doButton(btnLeftFirst)" />
                                <Button v-else
                                    @click="doButton(btnLeftFirst)" 
                                    :label="btnLeftFirst.label"
                                    :icon="btnLeftFirst.icon" 
                                    :iconPos="btnRightFirst.iconPos" 
                                    :class="btnLeftFirst.class" 
                                    :rounded="btnLeftFirst.rounded" 
                                    :severity="btnLeftFirst.severity"
                                    size="small" class="border-none" />
                            </div>

                            <!--Backward-->
                            <Button v-else-if="btnLeftFirst.type=='backward'"
                                @click="goBack()" 
                                :label="btnLeftFirst.label"
                                :icon="btnLeftFirst.icon" 
                                :iconPos="btnRightFirst.iconPos" 
                                :class="btnLeftFirst.class" 
                                :rounded="btnLeftFirst.rounded" 
                                :severity="btnLeftFirst.severity"
                                size="small" class="border-none" />

                            <Button v-else 
                                @click="doButton(btnLeftFirst)" 
                                :label="btnLeftFirst.label"
                                :icon="btnLeftFirst.icon" 
                                :iconPos="btnRightFirst.iconPos" 
                                :class="btnLeftFirst.class" 
                                :rounded="btnLeftFirst.rounded" 
                                :severity="btnLeftFirst.severity"
                                size="small" class="border-none" />
                        </div>

                        <!--LEFT SECOND-->
                        <Button v-if="btnLeftSecond && btnLeftSecond.visible"
                            @click="doButton(btnLeftSecond)" 
                            :label="btnLeftSecond.label"
                            :icon="btnLeftSecond.icon" 
                            :iconPos="btnLeftSecond.iconPos" 
                            :class="btnLeftSecond.class" 
                            :rounded="btnLeftSecond.rounded" 
                            :severity="btnLeftSecond.severity"
                            size="small" class="border-none" />
                    </div>
                </slot>
                <slot name="center">
                    <div class="flex flex-1 text-500 align-items-center align-items-center text-center text-sm font-medium">
                        <span class="relative w-full">{{ title }}</span>
                    </div>
                </slot>
                <slot name="right">
                    <div class="flex gap-2">
                    <!--RIGHT SECOND-->
                    <Button v-if="btnRightSecond && btnRightSecond.visible" 
                        @click="doButton(btnRightSecond)" 
                        :label="btnRightSecond.label"
                        :icon="btnRightSecond.icon"
                        :iconPos="btnRightSecond.iconPos" 
                        :class="btnRightSecond.class" 
                        :rounded="btnRightSecond.rounded" 
                        :severity="btnRightSecond.severity"
                        size="small" class="border-none"/>

                    <!--RIGHT FIRST-->
                    <Button v-if="btnRightFirst && btnRightFirst.visible" 
                        @click="doButton(btnRightFirst)" 
                        :label="btnRightFirst.label"
                        :icon="btnRightFirst.icon"
                        :iconPos="btnRightFirst.iconPos" 
                        :class="btnRightFirst.class" 
                        :rounded="btnRightFirst.rounded" 
                        :severity="btnRightFirst.severity"
                        size="small" class="border-none"/>
                    </div>
                </slot>
            </div>
        </div>
    </div>
    <div class="block" style="height:62px" :class="(hideHeader) ? 'surface-200' : ''"></div>
</template>

<script>
import { useRoute } from    'vue-router'
import { mapActions } from  'vuex'

export default {
    name: 'HeaderMob',
    data() {
        return {
            title: '',
            userPhoto: null,
            route: null,
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        title() { return this.$store.getters.StateHeaderTitle },
        userPhoto: function () { return this.$store.getters.StateUserPhoto },
        isAuth: function () { return this.$store.getters.isAuthenticated },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        ref: function () { return this.$store.getters.StateUserRef },
        botName: function () { return this.$store.getters.StateBotUsername },
        btnLeftFirst() { return this.$store.getters.StateHeaderBtnLeftFirst },
        btnLeftSecond() { return this.$store.getters.StateHeaderBtnLeftSecond },
        btnRightFirst() { return this.$store.getters.StateHeaderBtnRightFirst },
        btnRightSecond() { return this.$store.getters.StateHeaderBtnRightSecond },
    },
    methods: {
        ...mapActions(['ActionGetAllWallets']),
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        invite(){
            if(!this.ref) {
                this.$router.push({ path: '/personal/partner/' });
                return
            }
            if(this.isTgApp) {
                if(this.ref) this.inviteTg(this.ref)
                else this.showMess('error', 'Ошибка', 'Ваш браузер не поддерживает функцию приглашения')
            } else {
                if (navigator.share) {
                    navigator.share({
                        title: "PayWave – Сервис денежных переводов",
                        text: "Переводите деньги в пару кликов с PayWave",
                        url: "https://pay-wave.co"
                    }).then(() => console.log("Успешно поделились"))
                    .catch((error) => console.error("Ошибка:", error));
                } else {
                    this.$router.push({ path: '/personal/partner/' })
                }
            }
        },
        inviteTg(code){
            if(!code) return
            const link = `t.me/${this.botName}/app?startapp=ref-${code}`
            const text = 'Удобный сервис быстрых переводов в пару кликов.'
            window.open(`https://t.me/share/url?url=${link}&text=${text}`, '_blank')
        },
        goBack() {
            try { this.$router.go(-1) } 
            catch (e) { this.$router.push({ path: '/' }) }
        },
        doButton(button) {
            if(!button) return
            if(button.action && this[button.action]) {
                this[button.action]()
                try{ window.Telegram.WebApp.HapticFeedback.impactOccurred('light') } catch {}
            } else if(button.link) {
                this.$router.push({ path: button.link })
                try{ window.Telegram.WebApp.HapticFeedback.impactOccurred('light') } catch {}
                try{ window.scrollTo({ top: 0, behavior: 'smooth' }) } catch {}
            } else {
                console.warn(`Button action or link not found for ${button.label}`)
            }
        }
    },
    mounted(){
        const route = useRoute()
        this.route = route
    }
}
</script>